import { render, staticRenderFns } from "./ChartYourPosition.vue?vue&type=template&id=72fdf3f6&scoped=true"
import script from "./ChartYourPosition.vue?vue&type=script&lang=js"
export * from "./ChartYourPosition.vue?vue&type=script&lang=js"
import style0 from "./ChartYourPosition.vue?vue&type=style&index=0&id=72fdf3f6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72fdf3f6",
  null
  
)

export default component.exports